import { Checkbox, FormControlLabel, FormHelperText } from "@material-ui/core"
import { useRouter } from "next/router"
import React from "react"
import styled from "styled-components"

const StyledContainer = styled.div<{ $isEnglish?: boolean }>`
  display: flex;
  flex-direction: column;
  ${(p) => (p.$isEnglish ? `margin-left: -7px` : `margin-right: -7px`)};

  .MuiFormControlLabel-root {
    display: flex;
    align-items: center;
    margin-right: 0px;
    margin-left: 0px;
  }
  .MuiFormControlLabel-label {
    text-align: start !important;
    font-size: 12px;
    line-height: 1.2;
  }
`
// const StyledCheckboxWithLabel = styled(CheckboxWithLabel)<{
//   $english: boolean
// }>`
//   padding: 0;
//   ${(p) => (p.$english ? `margin-right: 7px` : `margin-left: 7px`)}
// `

const StyledError = styled(FormHelperText)`
  /* position: absolute; */
  bottom: -0.5em;
  right: 1px;
`
export interface FormikCheckboxFieldProps {
  name: string
  label?: React.ReactNode
  required?: boolean
  inputRef?: React.RefObject<HTMLButtonElement>
  checked?: boolean
  children?: React.ReactNode
  onChange?: (e: React.ChangeEvent<HTMLInputElement>, name: string) => void
  error?: boolean
  helperText?: React.ReactNode
  value?: string
}

const MuiCheckbox = ({
  name,
  label,
  required,
  inputRef,
  onChange,
  children,
  error,
  helperText,
  value,
  ...props
}: FormikCheckboxFieldProps) => {
  const { locale } = useRouter()
  return (
    <StyledContainer $isEnglish={locale === "en"}>
      <FormControlLabel
        control={
          <Checkbox
            onChange={(e) => onChange(e, name)}
            name={name}
            ref={inputRef}
            value={value}
            {...props}
          />
        }
        label={
          <>
            {label}
            {children}
          </>
        }
      />
      <StyledError id={`${name}-helper-text`}>{helperText}</StyledError>
      {error && required && (
        <StyledError id={`${name}-helper-text`}>{helperText}</StyledError>
      )}
    </StyledContainer>
  )
}

export default MuiCheckbox
